export const PLUGIN_KEY = "plugin-pages";
export const LUCID_VERSION = "0.x.x";

export default {
	collectionFieldBrickId: "collection-pseudo-brick",
	fields: {
		parentPage: {
			key: "parentPage",
		},
		slug: {
			key: "slug",
		},
		fullSlug: {
			key: "fullSlug",
		},
	},
};
